import { isArrayWithItems as i } from "../../../helpers/array-helper.js";
import "react/jsx-runtime";
import "dayjs";
const s = (e) => e || "", m = (e) => i(e) ? e.map((r) => {
  const t = [
    s(r.stationName),
    s(r.city),
    s(r.municipality),
    s(r.county),
    r.trailerRental ? "hyrsläp" : "",
    r.carWashAutomatic ? "biltvätt" : "",
    r.electricConnectors && r.electricConnectors.length > 0 ? "laddning elbil" : ""
  ];
  return {
    ...r,
    searchIndex: t.filter((c) => c).map((c) => c.toLowerCase()).join(" ")
  };
}) : [], o = (e, n) => n.every((t) => e.searchIndex ? e.searchIndex.startsWith(t) || e.searchIndex.includes(t) : !1), u = (e, n) => {
  if (n.length < 2)
    return e;
  const t = n.toLowerCase().split(" ");
  return e.filter((a) => o(a, t));
};
export {
  m as extendStationsWithSearchIndex,
  u as filterStationsBySearchTerm
};
